import "../global.d.js";
import { validateTidalLicense } from "../base/index.js";
import * as applicationStorage from "./ApplicationStorage.js";
export * from "./deepmerge/deepmerge.js";
export * from "./isPlainObject.js";
export * from "./smartLazy/smartLazy.js";
validateTidalLicense();
export {
  applicationStorage
};
//# sourceMappingURL=index.js.map
